import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const FormBox = styled.div`
  ${media.md`
  padding: 21px 26px;
  border: 1px solid #efefef;
  border-radius: 3px;
`};
`;
